<template>
  <div id="topic-panel" :class="$mq" class="showcase wrapper py-6" :style="{ minHeight: this.$store.getters.fullWindowHeightMinusFooter }">
  <!-- em. minHeight EI TOIMI JOSTAINN SYYSTÄ!!! -->

    <!-- sisältö -->
    <div class="card main-card pt-14 pb-6 px-10 oflow-hidden">
      <!-- navigation -->
      <div class="absolute flex py-2 px-3 rounded-3 mt-2 opacity-6 hover-opa-10 color-theme noselect" style="top: 0; left: 50%; transform: translateX(-50%);">
        <i @click="navigate('prev')" class="material-icons mr-2">keyboard_arrow_left</i>
        <i @click="navigate('')" class="material-icons">undo</i>
        <i @click="navigate('next')" class="material-icons ml-2">keyboard_arrow_right</i>
      </div>

      <!-- <p>{{this.$store.state.categories}}</p> -->

      <div v-if="currentTopic" class="mean-content-wrapper mean-card-main-info" style="max-width: 750px; margin: 0 auto;">
        <!-- info + main-teksti -->
        <h2 class="header-main mb-2 txt-bold break-word">{{ this.currentTopic.title }}</h2>
        <span v-if="currentTopic.author" class="handle block mt-2 mb-6 font-9 color-grey-l1 txt-bold">{{ this.currentTopic.author }}</span>
        <div v-html="currentTopic.mainInfo" class="text-content-html mt-4"></div>

        <!-- tähän tulee toolbox.vue -->
        <toolbox v-if="currentTopic.slug === 'mika-tama-sovellus-on?'" class="my-6"></toolbox> <!-- TÄMÄ KOVAKOODATTU -> EI PARAS RATKAISU :/ -->

        <!-- four-field -->
        <fourField v-if="currentTopic.RADIO === 'four'" :data="fourFieldDataForComponent" class="topic-four-field my-4"></fourField>
        <!-- <fourField v-if="currentTopic.RADIO === 'four'" v-model="currentFourField" :data="fourFieldDataForComponent"></fourField> -->

        <!-- many-field -->
        <manyField v-if="currentTopic.RADIO === 'many'" :data="manyFieldDataForComponent" class="topic-many-field"></manyField>
      </div>

    </div>

  </div>
</template>

<script>
// import db from '@/firebase/init'
// import { mapState } from 'vuex' // poistuu!!!!!!!!
import fourField from '@/components/fourField.vue'
import manyField from '@/components/manyField.vue'
import toolbox from '@/components/toolbox.vue'

export default {
  name: 'mean',

  components: {
    fourField,
    manyField,
    toolbox
  },

  data () {
    return {
      currentFourField: 'A'
      // slugs: []
    }
  },

  created () {
    this.$store.dispatch('storeTopics')
    // this.$store.dispatch('storeCategories')
  },
  /*
  created () {
    this.vuexTopics.forEach(topic => {
      this.slugs.push(topic.slug)
    })
  } */

  computed: {
    // ...mapState(['vuexTopics']), // poistuu!!!!!!!!

    /* slugs() {
      let topics = this.$store.state.topics
      topics.forEach(topic => {
        this.slugs.push(topic.slug)
      })
    }, */

    currentTopic () {
      let topics = this.$store.state.topics
      let current = topics.find(topic => {
        return topic.slug === this.$route.params.topic_id
      })
      return current
    },

    fourFieldDataForComponent () {
      return {
        descrTop: this.currentTopic.fourDescrTop,
        descrBottom: this.currentTopic.fourDescrBottom,
        descrLeft: this.currentTopic.fourDescrLeft,
        descrRight: this.currentTopic.fourDescrRight,
        four1: this.currentTopic.fourHeader1,
        fourMainInfo1: this.currentTopic.fourMainInfo1,
        four2: this.currentTopic.fourHeader2,
        fourMainInfo2: this.currentTopic.fourMainInfo2,
        four3: this.currentTopic.fourHeader3,
        fourMainInfo3: this.currentTopic.fourMainInfo3,
        four4: this.currentTopic.fourHeader4,
        fourMainInfo4: this.currentTopic.fourMainInfo4
      }
    },

    manyFieldDataForComponent () {
      return {
        many1: this.currentTopic.manyHeader1,
        manyMainInfo1: this.currentTopic.manyMainInfo1,
        many2: this.currentTopic.manyHeader2,
        manyMainInfo2: this.currentTopic.manyMainInfo2,
        many3: this.currentTopic.manyHeader3,
        manyMainInfo3: this.currentTopic.manyMainInfo3,
        many4: this.currentTopic.manyHeader4,
        manyMainInfo4: this.currentTopic.manyMainInfo4,
        many5: this.currentTopic.manyHeader5,
        manyMainInfo5: this.currentTopic.manyMainInfo5,
        many6: this.currentTopic.manyHeader6,
        manyMainInfo6: this.currentTopic.manyMainInfo6,
        many7: this.currentTopic.manyHeader7,
        manyMainInfo7: this.currentTopic.manyMainInfo7,
        many8: this.currentTopic.manyHeader8,
        manyMainInfo8: this.currentTopic.manyMainInfo8,
        many9: this.currentTopic.manyHeader9,
        manyMainInfo9: this.currentTopic.manyMainInfo9,
        many10: this.currentTopic.manyHeader10,
        many1MainInfo10: this.currentTopic.manyMainInfo10
      }
    }
  },

  methods: {
    navigate (where) {
      let slugs = this.$store.getters.topicSlugs
      // console.log(slugs, 'slugs');

      let thisIndex = slugs.indexOf(this.$route.params.topic_id)
      // console.log(thisIndex, 'inndexi');

      if (where === 'prev') {
        if (thisIndex === 0) {
          thisIndex = slugs.length
        }
        thisIndex = thisIndex - 1
        this.$router.push({ name: 'aihe', params: { topic_id: slugs[thisIndex] } })
      } else if (where === 'next') {
        thisIndex = thisIndex + 1
        thisIndex = thisIndex % slugs.length
        this.$router.push({ name: 'aihe', params: { topic_id: slugs[thisIndex] } })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss">
#topic-panel {
  max-width: 950px !important;
  h2 {
    font-size: 2rem;
  }
  &.phone h2 { font-size: 1.3rem; }
  .handle {
    margin-top: 10px;
    font-size: 1rem;
  }
  p {
    font-size: 0.85rem;
  }
}
</style>
